export default "__VITE_ASSET__b9fb96be__"